import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import removeHTML from 'shared/utils/removeHTML';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import withRouter from 'shared/utils/WithRouter';

export const styles = {
	buttonDiv: {
		textAlign: 'center',
	},
	headline: {
		textAlign: 'center',
	},
	message: {
		textAlign: 'center',
		padding: '15px 0',
	},
	paper: {
		width: '100%',
		maxWidth: '800px',
		height: 'auto',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '8px',
	},
	paperDiv: {
		padding: '25px',
	},
};

const SalespersonRequired = ({ classes, settings, router }) => (
	<Paper elevation={6} className={classes.paper}>
		<div className={classes.paperDiv}>
			<Typography type="headline" gutterBottom className={classes.headline}>
				{settings.fieldAndFooterSettings.SalespersonRequiredPageSettings.SalespersonRequiredPageTitle}
			</Typography>
			<Typography type="body1" className={classes.message}>
				<div
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{
						__html: removeHTML(settings.fieldAndFooterSettings.SalespersonRequiredPageSettings.SalespersonRequiredPageText),
					}}
				/>
			</Typography>
			<div className={classes.buttonDiv}>
				<Button variant="contained" color="primary" onClick={() => router.navigate('/now')}>
					Okay
				</Button>
			</div>
		</div>
	</Paper>
);

SalespersonRequired.propTypes = {
	classes: PropTypes.shape({}).isRequired,
	settings: PropTypes.shape({}).isRequired,
};

export default withRouter(withStyles(styles, { name: 'SalespersonRequired' })(SalespersonRequired));
